module.exports = __webpack_public_path__ + "img/tours_5.520deb99.jpg";